import React from 'react'
import './PhotoLiner.css';
import SafeArea from '../safe-area';

interface Props {
    title: string;
    color: string;
    customClass?: string;
    customIcon?: React.ReactNode;
    showLine?: boolean;
}

const PhotoLiner: React.FC<Props> = ({ title, color, customClass = "cormorant fs14 up", customIcon, showLine = false }) => {
    return (
        <div className="liner">
            <SafeArea>
                <>
                    {showLine && <div style={{ height: 1, backgroundColor: color, width: '100%', marginBottom: '16px' }} />}
                    <div className="d-flex aic jcs">
                        {customIcon && customIcon}
                        <div className={customClass} style={{ color: color, letterSpacing: '1px' }}>{title}</div>
                    </div>
                </>
            </SafeArea>
        </div>
    )
}

export default PhotoLiner
